<div id="about" class="about-area ptb-100">
  <img src="../../../assets/Images/coming.jpg" />
</div>
